<!--パーツ(3)：搭乗者情報ブロック-->
<div id="{{ id }}" class="p-booking-info-mdl__item">
  <!--パーツ(4)：搭乗者情報ヘッダ(Close時)-->
  <asw-passenger-information-request-passenger-header-close
    #closeHeaderComp
    [id]="id"
    [(isOpen)]="isOpen"
    [parts]="parts.closeHeader"
    [(data)]="closeHeader"
  ></asw-passenger-information-request-passenger-header-close>

  <!--パーツ(5)搭乗者情報詳細（classによってコンテンツ開閉）-->
  <div
    id="{{ id }}-passenger-header-close-drawer-option1"
    class="p-booking-info-mdl__contents"
    [ngClass]="{ 'is-open': isOpen }"
  >
    <!--パーツ(4)：搭乗者情報ヘッダ(Open時)-->
    <asw-passenger-information-request-passenger-header-open
      #openHeaderComp
      [id]="id"
      [(isOpen)]="isOpen"
      [parts]="parts.openHeader"
      [(data)]="openHeader"
    ></asw-passenger-information-request-passenger-header-open>

    <!--パーツ(6)：搭乗者基本情報-->
    <asw-passenger-information-request-passenger-basic-info
      #basicInfoComp
      [id]="id + '-passenger-basic-info'"
      [parts]="parts.basicInformation"
      [(data)]="basicInformation"
    ></asw-passenger-information-request-passenger-basic-info>

    <!--パーツ(7)：パスポート番号-->
    <asw-passenger-information-request-passenger-passport
      #passportComp
      *ngIf="parts.isExistsTravelSkyHostedAirline"
      [id]="id + '-passenger-passport'"
      [parts]="parts.passport"
      [(data)]="passport"
    ></asw-passenger-information-request-passenger-passport>

    <!--パーツ(8)：FFP情報-->
    <asw-passenger-information-request-passenger-ffp
      #ffpDataComp
      *ngIf="parts.isNotInf"
      [id]="id + '-passenger-ffp'"
      [parts]="parts.ffpData"
      [(data)]="ffpData"
    ></asw-passenger-information-request-passenger-ffp>

    <!--パーツ FY25：障がい割旅客種別-->
    <asw-passenger-disability-discount
      #disabilityComp
      *ngIf="parts.isDisability"
      [id]="id + '-passenger-disability'"
      [parts]="parts.disability"
      [(data)]="disability"
    ></asw-passenger-disability-discount>
    <!--パーツ FY25：離島カード番号-->
    <asw-passenger-island-card
      #islandComp
      *ngIf="parts.isIsland"
      [id]="id + '-passenger-island'"
      [parts]="parts.island"
      [(data)]="island"
    ></asw-passenger-island-card>
    <!--パーツ(9)：搭乗者連絡先情報-->
    <asw-passenger-information-request-passenger-contact
      #contactComp
      *ngIf="parts.isNotInf"
      [id]="id + '-passenger-contact'"
      [parts]="parts.contact"
      [(data)]="contact"
    ></asw-passenger-information-request-passenger-contact>

    <!--パーツ(10)：追加情報-->
    <div class="p-booking-info-mdl__section p-booking-info-mdl__section--pb0" *ngIf="parts.isAdditionalInfo">
      <div class="p-booking-info-mdl__block">
        <div
          class="p-booking-info-mdl__heading p-booking-info-mdl__heading--01 p-booking-info-mdl__heading--additional"
        >
          <h3 class="p-booking-info-mdl__heading-title" [innerHTML]="'label.additionalInformation' | staticMsg"></h3>
        </div>
        <div class="p-booking-info-mdl__additional">
          <!--パーツ(11)：発着通知連絡先情報-->
          <asw-passenger-information-request-passenger-arrival-departure-notice
            #arrivalAndDepartureNoticeComp
            *ngIf="parts.isDepartureArrivalNotificationEligible"
            [id]="id + '-passenger-arrival-departure-notice'"
            [parts]="parts.arrivalAndDepartureNotice"
            [(data)]="arrivalAndDepartureNotice"
          ></asw-passenger-information-request-passenger-arrival-departure-notice>

          <!--パーツ(12)：サポート情報表示-->
          <asw-passenger-information-request-passenger-support
            #supportComp
            *ngIf="parts.isTravelerSupportsEligible"
            [id]="id + '-passenger-support'"
            [parts]="parts.support"
            [(data)]="support"
          ></asw-passenger-information-request-passenger-support>
        </div>
      </div>
    </div>

    <!--パーツ(13)：閉じる-->
    <div *ngIf="parts.isCloseEnable" class="p-booking-info-mdl__section">
      <div class="p-booking-info-mdl__block">
        <div class="p-booking-info-mdl__close">
          <button
            id="{{ id }}-close-button"
            class="p-booking-info-mdl__close-btn"
            [attr.aria-controls]="id + '-passenger-header-close-drawer-option1'"
            [attr.aria-expanded]="isOpen"
            (click)="clickClose()"
          >
            <span class="p-booking-info-mdl__close-text" [innerHTML]="'label.fold' | staticMsg"></span>
          </button>
        </div>
      </div>
    </div>

    <!--パーツ(14)：入力完了操作エリア-->
    <asw-passenger-information-request-input-complete-operation-area
      [id]="id + '-passenger-complete'"
      *ngIf="parts.isEnableComplete"
      id="{{ id }}-passengerInformation"
      [parts]="inputCompleteOperationData"
      (nextEvent)="clickNextButton()"
      (saveEvent)="clickSaveButton()"
    ></asw-passenger-information-request-input-complete-operation-area>
  </div>
</div>
